import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faCaretDown,
  faImageSlash,
  faBook,
  faCheck,
} from '@fortawesome/pro-solid-svg-icons';
import {addDefaultSrc, addProtocolToDomain, copyAndModifyQueryParams, findValidDomain, getDomain, getSingleUrlParam, getSiteName, isOTTOV2PublicPage, isValidDomain} from '@/utils/url';
import {useRouter} from 'next/router';
import {Button} from '@/components/common-components/v2';
import React, {useEffect, useRef, useState} from 'react';
import {
  Col, Row,
  Dropdown,
  Tooltip,
  Spin,
  Menu,
} from 'antd';
import {useStore} from '@/store/root-store';
import {openUrl} from '@/utils/router';
import {SettingsModal} from '../../otto-page-v2-main/Component/settings-modal';
import {ImportBusinessModalV2} from '../Modals/importBusinessModal';
import OttoSummary from './ottoSummary';
import {NextImg} from '@/utils/nextImg';
import OttoCtaSection from './ottoCtaSection';
import {toJS} from 'mobx';
import {TopupModal} from '../Modals/topupModal';
import {RingLoaderV2} from '@/components/common-components/components/skeleton/ring-loader-v2';
import {faMagnifyingGlass, faEllipsisVertical} from '@fortawesome/pro-regular-svg-icons';
import {debounce} from 'lodash';
import {DropdownContainer, Img, OttoProjectSearchInput, ProjectName, BoldText, OverlayContainer} from './styleComponents';
import {LoadingOutlined} from '@ant-design/icons';
import WidgetModal from '../../otto-page-v2-main/add-site-modal';
import {StyledSpin} from '../Utils/styledSpin';
import DeepFreezeModal from './deepFreezeModal';
import {faBoxArchive, faLink} from '@fortawesome/pro-duotone-svg-icons';
import FreezeWrapper from './freezTooltip';
import moment from 'moment';
import PublicPageFreezeWrapper from './publicPageFreeze';
import {CrawlBudgetBanner} from '@/components/common-components/components/crawl-budget-banner';
import {OttoDetailKnowledgeGraph} from './OttoDetailKnowledgeGraph';

interface Props {
  isCompleted?: boolean;
}

type optionsType = 'quantity'
| 'additionally_included'
| 'current_quota'
| 'used_card'
| 'recurring_payment';

interface TopUpVisibilityProps {
  visibility: boolean;
  price: number;
  title: string;
  options: optionsType[];
  consumed: number | null;
  total: number | null;
  recurring: string;
  quotaKey: string;
  desc: string;
  nextPaymentAt?: string | null;
  buttonTxt: string;
}

export const OttoDetailPageV2Header:React.FC<Props> = observer(() => {
  const {
    ottoV2Store: {getOttoV2Project, loadingProject, setAutoPilot, loadingAutoPilot, getOttoV2ProjectsList, setDefaultParams, loadOttoV2Project, getKnowledgeGraphFieldsMeta, getKnowledgeGraphData, setIsDeploying, getOttoQuotaAllocations, getOttoPlanQuotaAllocations,
      isKnowledgeModalVisible, setIsKnowledgeModalVisible, defaultParams, loadingProjects, loadmoreLoading, getExportTaskId, loadingWorkSummary, getOttoKnowledgeGraphFieldsMeta, unfreezeOttoProject, unfreezeLoading, getGenesysApiKey, setGenesysApiKey, getBlockedQuotas, getPaymentTopups},
    gsc: {googleAnalytics: {setGaDataModal, gaDataModal, getGMBSetting}, criteria},
    siteAuditorV2: {
      setGscOpenModalValue,
      siteAuditSelectedProperty,
      updateSelectedSiteSA,
      loadAuditedSitesList,
      onLoadAuditedSiteDetail,
      getAuditedSiteDetailData,
      siteAuditSpacificData,
      siteAuditSpacificDataLoading,
      resetAuditedSiteDetail,
      resetDetectedCms,
    },
    ottoStore: {
      setDomainLoading,
    },
    navBar: {setShouldToggleSider},
    settings: {customer: {profile: {whitelabelOtto, isWhitelabel, isParentAccount, isLinkgraph}}},
  } = useStore('');
  const [tooltipShown, setTooltipShown] = useState(localStorage.getItem('TOOLTIP_SHOWN'));
  const domainName = getOttoV2Project?.hostname || getSingleUrlParam('domain');
  const uuid = getSingleUrlParam('uuid');
  const router = useRouter();
  const projectId = (siteAuditSelectedProperty ? siteAuditSelectedProperty : (localStorage.getItem('lastPropertySiteAudit') || getOttoV2Project?.siteAuditId))?.toString();
  const [currentProject, setCurrentProject] = useState(null);
  const [currentProjectLoader, setCurrentProjectLoader] = useState(true);
  const [settingsModal, setSettingsModal] = useState(false);
  const [gbpModalVisible, setGbpModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [createProjectUuid, setCreateProjectUuid] = useState('');
  const [settingsData, setSettingsData] = useState<{
    domainToOpen: string;
    page?: string;
  }>(null);
  const formRef = useRef(null);
  const [topUpBulkVisibility, setTopUpBulkVisibility] = useState<TopUpVisibilityProps>({
    visibility: false,
    price: 0,
    title: '',
    options: [],
    consumed: 0,
    total: 0,
    recurring: '',
    quotaKey: '',
    desc: '',
    buttonTxt: '',
  });
  const [knowledgeGraphInitialLoader, setKnowledgeGraphInitialLoader] = useState(true);

  const [showProjectDropdown, setShowProjectDropdown] = useState(false);

  const [isWidgetModalVisible, setIsWidgetModalVisible] = useState(false);
  const [deepFreezeModalVisible, setDeepFreezeModalVisible] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [callLoadAudit, setCallLoadAudit] = useState(false);
  const isPublicHash = !!getSingleUrlParam('public_hash');

  const handleLaterClick = () => {
    localStorage.setItem('TOOLTIP_SHOWN', 'true');
    setTooltipShown('true');
  };

  useEffect(() => {
    if (!isPublicHash) getPaymentTopups();
    setTooltipShown(localStorage.getItem('TOOLTIP_SHOWN'));
  }, []);

  useEffect(() => {
    setDefaultParams({search: '', pageSize: 20, page: 1});
    if (!isPublicHash) {
      getBlockedQuotas();
      getGMBSetting();
      getKnowledgeGraphFieldsMeta();
      getOttoQuotaAllocations();
      getOttoPlanQuotaAllocations();
      loadAuditedSitesList();
    }
    return () => setDefaultParams({...defaultParams, pageSize: 20, page: 1, search: ''}, true);
  }, []);

  const getKnowledgeGraph = async () => {
    if (getOttoV2Project?.knowledgeGraphId && !isPublicHash) {
      setKnowledgeGraphInitialLoader(true);
      await getKnowledgeGraphData(getOttoV2Project?.knowledgeGraphId);
      setKnowledgeGraphInitialLoader(false);
    }
  };

  useEffect(() => {
    getKnowledgeGraph();
  }, [getOttoV2Project?.knowledgeGraphId]);

  useEffect(() => {
    if (getOttoV2Project?.uuid && getOttoV2Project?.uuid == uuid) {
      setCurrentProject(getOttoV2Project?.uuid == uuid && getOttoV2Project);
      setCurrentProjectLoader(false);
      if (isLinkgraph && !isPublicHash) getGenesysApiKey();
    }
  }, [getOttoV2Project]);

  const projectImg = <NextImg style={{height: '42px', width: '42px', borderRadius: '4px'}} src={`https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${domainName && getDomain((!/^(https?:)?\/\//i.test(domainName)) ? 'https:' + domainName : domainName)}&size=64`}/>;

  const isFromhomepage = getSingleUrlParam('fromHome');
  const handleBackRedirect = () => {
    setGenesysApiKey('');
    if (router?.pathname?.includes('public')) {
      router.push(`/otto-page-public`);
    } else {
      if (isFromhomepage) {
        router.push(`/home`);
      } else {
        router.push(`/seo-automation`);
      }
    }
  };

  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const beforeRadius = {
    min: 0,
    max: 0,
  };

  if (getOttoV2Project?.beforeSummary['seoOptimizationScore'] && getOttoV2Project?.beforeSummary['seoOptimizationScore'] !== 'undefined' && getOttoV2Project?.beforeSummary['seoOptimizationScore'] > 50) {
    beforeRadius.max = getOttoV2Project?.beforeSummary['seoOptimizationScore'];
    beforeRadius.min = 100 - getOttoV2Project?.beforeSummary['seoOptimizationScore'];
  } else {
    beforeRadius.min = 100 -getOttoV2Project?.beforeSummary['seoOptimizationScore'];
    beforeRadius.max = getOttoV2Project?.beforeSummary['seoOptimizationScore'];
  }

  const handleOpenGSCModal = isGaObject => {
    const connectedData = isGaObject?.connectedData;
    criteria.updateCriteria({
      ...criteria,
      property: connectedData?.gscDetails?.propertyUrl || connectedData?.gscDetails?.propertyUrl === null ? connectedData?.gscDetails?.propertyUrl : '',
    });
    setGscOpenModalValue(true, 'GSC Setting', true, projectId, false);
    setGaDataModal({
      ...gaDataModal,
      visible: true,
      siteUrl: connectedData?.gscDetails?.propertyUrl || '',
      gaConnected: isGaObject?.isGscConnected,
      settingId: null,
      settingsEnabled: false,
      hasSiteGaCredentials: null,
      saProjectId: projectId,
      countryCode: connectedData?.gscDetails?.countryCode || connectedData?.gscDetails?.countryCode === null ? connectedData?.gscDetails?.countryCode : '',
      fromOttoUuidParam: `?uuid=${uuid}`,
    });
  };

  const onChangeAutoPilot = async value => {
    setIsDeploying(true);
    await setAutoPilot(uuid, value);
  };

  const openSettings = () => {
    if (currentProject) {
      handleLaterClick();
      setSettingsModal(true);
      setSettingsData({
        domainToOpen: currentProject?.hostname,
        page: 'detail-page',
      });
    }
  };

  const resetForms = () => {
    if (formRef?.current) {
      formRef.current.resetFields();
    }
  };

  useEffect(() => {
    return () => {
      setShouldToggleSider(true);
    };
  }, []);

  const initialValues = () => {
    resetForms();
  };

  useEffect(() => {
    if (!getOttoV2Project) return;
    if (getOttoV2Project?.siteAudit && !isPublicHash && (!getAuditedSiteDetailData || getAuditedSiteDetailData?.shouldRepoll || !callLoadAudit)) {
      setCallLoadAudit(true);
      onLoadAuditedSiteDetail(getOttoV2Project?.siteAudit);
    }
  }, [getOttoV2Project, isKnowledgeModalVisible]);

  useEffect(() => {
    const topPages = {name: 'top_pages', label: 'Top pages', value: []};
    const sections = toJS(getOttoKnowledgeGraphFieldsMeta?.value);
    const alreadyExist = sections?.find(item => item.name === 'top_pages');
    if (!alreadyExist) {
      sections?.splice(1, 0, topPages);
    }
  }, [getOttoKnowledgeGraphFieldsMeta]);

  const tableFilterHandler = debounce(async e => {
    if (e?.target?.value) {
      const passedValue = e.target.value;
      setDefaultParams({...defaultParams, pageSize: 20, page: 1, search: passedValue.toLowerCase()}, false, false);
    } else {
      setDefaultParams({search: '', pageSize: 20, page: 1});
    }
  }, 500);

  const handleSeeTask = items => {
    setDomainLoading();
    setGenesysApiKey('');
    updateSelectedSiteSA(items?.siteAudit);
    initialValues();
    resetAuditedSiteDetail();
    loadOttoV2Project(items?.uuid);
    resetDetectedCms();
    const params = [{
      key: 'uuid',
      value: items?.uuid,
    }, {
      key: 'subGroup', value: '',
    }];
    router.push(`${copyAndModifyQueryParams(params)}`, undefined, {shallow: true});
    setShowProjectDropdown(false);
  };
  const onExportWorkSummary = async () => {
    await getExportTaskId(uuid);
  };

  const knowledgeBaseUrl = 'https://intercom.help/search-atlas/en/collections/10864692-knowledge-base';
  const projectListRef = useRef(null);

  const ottoProjectsList = (
    <DropdownContainer>
      <div className='heading'>
        <div className='total-otto-sites'>{getOttoV2ProjectsList?.count} {whitelabelOtto} Sites found</div>
        <div className='add-new-side' onClick={() => {
          setIsWidgetModalVisible(true);
          setShowProjectDropdown(false);
        }}>+Add site</div>
      </div>
      <OttoProjectSearchInput onChange={e => tableFilterHandler(e)}
        placeholder='Search ...'
        prefix={<FontAwesomeIcon icon={faMagnifyingGlass} fontSize={'12px'} color='#A3A4A4'/>}
      />
      {loadingProjects ? <RingLoaderV2 style={{marginTop: '10px'}} /> :
        <div className='project-list' ref={projectListRef}>
          {getOttoV2ProjectsList?.results?.map((item, index) => {
            const url = `https://www.google.com/s2/favicons?sz=64&domain_url=${addProtocolToDomain(item?.hostname)}`;
            const isSelected = item?.uuid === uuid;
            return (
              <div className='project-container' style={{background: isSelected ? 'rgba(45, 108, 202, 0.15)' : ''}} key={index} onClick={() => handleSeeTask(item)}>
                <div className='project-image-name'>
                  <Img onError={e => addDefaultSrc(e)} src={isValidDomain(item?.hostname) ? url : `https://www.google.com/s2/favicons?sz=64&domain_url=${findValidDomain(item?.hostname)?.includes('.com') ? findValidDomain(item?.hostname) : `${findValidDomain(item?.hostname)}.com`}`} alt={item?.hostname}/>
                  <Tooltip title={item?.hostname || '-'} overlayInnerStyle={{whiteSpace: 'nowrap', width: 'fit-content', background: '#000'}}>
                    <BoldText style={isSelected ? {maxWidth: '180px'} : {}}>{item?.hostname || '-'}</BoldText>
                  </Tooltip>
                </div>
                {isSelected && <div className='selected'>Selected</div>}
              </div>
            );
          })}
          {getOttoV2ProjectsList?.results?.length < getOttoV2ProjectsList?.count && <div className='load-more'>
            <button
              className='load-more-btn'
              style={loadmoreLoading ? {cursor: 'not-allowed'} : {}}
              onClick={() => !loadmoreLoading && setDefaultParams({search: '', pageSize: 20, page: defaultParams.page + 1}, false, false, true)}
            >
            Load more {loadmoreLoading && <Spin indicator={<LoadingOutlined style={{fontSize: '12px', color: '#2D6CCA'}} spin />} />}
            </button>
          </div>}
        </div>}
    </DropdownContainer>
  );

  const overlay = (
    <OverlayContainer>
      <Menu.Item onClick={() => setDeepFreezeModalVisible(true)}>Deep Freeze this Site (Archive)</Menu.Item>
    </OverlayContainer>
  );

  const publicUrl = `${window.location.protocol}//${window.location.host}/seo-automation/public?uuid=${getOttoV2Project?.uuid}&category=All&subGroup=page_title&public_hash=${getOttoV2Project?.publicShareHash}`;

  const onVisibleChange = (visible:any) => {
    if (!visible) {
      setTimeout(() => {
        setCopySuccess(false);
      }, 300);
    }
  };

  const shareUrl = () => {
    navigator.clipboard.writeText(isOTTOV2PublicPage() ? location.href : publicUrl);
    setCopySuccess(true);
  };

  return (<>
    <HeaderWrapper>
      <HeadingContainer>

        {getAuditedSiteDetailData?.shouldAdjustCrawlBudget && <CrawlBudgetBanner onButtonClick={openSettings} pagesCount={getAuditedSiteDetailData?.totalUrlsInSitemaps} bannerStyle={{marginTop: '-26px'}}/>}
        {!isPublicHash && <BackContainer>
          <FontAwesomeIcon onClick={handleBackRedirect} icon={faArrowLeft} className='back-icon'/>
          <span onClick={handleBackRedirect} className='back-text'>Back to Sites List</span>
        </BackContainer>}
        <DomainWrapper isPublicPage={isPublicHash} isFrozen={getOttoV2Project?.isFrozen}>
          {currentProjectLoader ? <Spin indicator={<LoadingOutlined style={{fontSize: '30px', color: '#FFFFFF', marginTop: '10px', marginLeft: '50px'}} spin />} />: <DomainContainer>
            {
              domainName ? projectImg : <FontAwesomeIcon className='logo' icon={faImageSlash} />
            }
            <div>
              {!isPublicHash ? <Dropdown trigger={['click']} visible={showProjectDropdown} onVisibleChange={e => setShowProjectDropdown(e)} overlay={ottoProjectsList}>
                <ProjectName onClick={() => setShowProjectDropdown(true)}>
                  <div className='title'>{capitalizeFirstLetter(getSiteName(domainName)) ?? '-'}</div>
                  <FontAwesomeIcon icon={faCaretDown} />
                </ProjectName>
              </Dropdown> : (
                <ProjectName style={{cursor: 'auto'}} onClick={() => setShowProjectDropdown(true)}>
                  <div className='title'>{capitalizeFirstLetter(getSiteName(domainName)) ?? '-'}</div>
                </ProjectName>
              )}
              <LinkContainer>
                <Link onClick={()=>openUrl(`${addProtocolToDomain(domainName)}`, '_blank')}>{domainName}</Link>
                {siteAuditSpacificData?.detectedCms?.length ? <Tooltip overlayInnerStyle={{width: 'auto', borderRadius: '8px'}} placement='right' title={`${whitelabelOtto || 'OTTO'} Detected this site was built with ${capitalizeFirstLetter(siteAuditSpacificData?.detectedCms)}`}>
                  {(siteAuditSpacificDataLoading || loadingProject || (siteAuditSpacificData?.id && getOttoV2Project?.siteAudit !== siteAuditSpacificData?.id)) ? <Spin indicator={<LoadingOutlined style={{fontSize: '14px', color: '#FFFFFF'}} spin />} /> : <Cms>{capitalizeFirstLetter(siteAuditSpacificData?.detectedCms)}</Cms>}
                </Tooltip> : ''}
              </LinkContainer>
            </div>
          </DomainContainer>}
          <ButtonContainer>
            {(getOttoV2Project?.uuid === uuid) ? (<FreezeWrapper><StyledButton
              disabled={loadingWorkSummary || loadingProject}
              isSetting={true}
              style={{borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '8px', lineHeight: '20px'}}
              onClick={onExportWorkSummary}>
              <>{loadingWorkSummary ? <StyledSpin color={'#ffffff'} fontSize={14}/> : <img src='/icons/fileXls.svg' style={{width: '14px'}}/>}</>Export Work Summary
            </StyledButton></FreezeWrapper>) : <StyledSpin color={'#ffffff'} fontSize={14}/>}
            {(getOttoV2Project?.uuid === uuid) ?
              <Tooltip title={(isWhitelabel && !isParentAccount) && 'Feature visible only to the Agency Owner'}
                placement={'topRight'}
                overlayInnerStyle={{
                  width: 250,
                  padding: '10px',
                  background: '#0c0a09',
                  boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.08)',
                  borderRadius: 8,
                }}>
                <div>
                  <KnowledgeButton disabled={loadingProject || (isWhitelabel && !isParentAccount)}
                    onClick={()=> openUrl(knowledgeBaseUrl, '_blank')}
                    style={{display: 'flex', alignItems: 'center', gap: '8px', lineHeight: '20px', backgroundColor: '#4E515680'}}
                  >
                    <><FontAwesomeIcon icon={faBook} color={'#34AEF3'} /></>Knowledge Base</KnowledgeButton>
                </div>
              </Tooltip> :
              null}
            {!isPublicHash ? (getOttoV2Project?.uuid === uuid) ? <Tooltip
              title={<>
                {copySuccess && <span><FontAwesomeIcon icon={faCheck} style={{color: '#2AC155'}} />{` Copied to clipboard`}</span>}
              </>}
              placement='bottom'
              visible={copySuccess}
              onVisibleChange={visible => onVisibleChange(visible)}>
              <StyledButton
                disabled={loadingProject}
                isSetting={true}
                style={{borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '8px', lineHeight: '20px'}}
                onClick={() => shareUrl()}>
                <FontAwesomeIcon icon={faLink}/>Share URL
              </StyledButton>
            </Tooltip> : <StyledSpin color={'#ffffff'} fontSize={14}/>:''}


            {(!getOttoV2Project?.isFrozen && !isPublicHash) ? <Dropdown overlay={overlay} trigger={['click']}>
              <div className='menu' style={{cursor: 'pointer'}}>
                <FontAwesomeIcon icon={faEllipsisVertical} className='menu' />
              </div>
            </Dropdown> : ''}
          </ButtonContainer>
        </DomainWrapper>
        {getOttoV2Project?.isFrozen ? <FreezeBanner>
          <FontAwesomeIcon icon={faBoxArchive} color='#F1AA3E' />
          <div className='txt'>
             The changes on this site are frozen as of {moment(getOttoV2Project?.frozenAt)?.format('MMMM DD, YYYY')}. You will be unable to make any modifications unless you {' '}
            {unfreezeLoading ? isPublicHash ? '' : <Spin indicator={<LoadingOutlined style={{fontSize: '14px', color: '#FFFFFF'}} spin />} /> :
              <PublicPageFreezeWrapper><span className='unfreeze-button' onClick={() => !unfreezeLoading && unfreezeOttoProject(uuid)}>unfreeze the site.</span></PublicPageFreezeWrapper>}
          </div>
        </FreezeBanner> : ''}
        {getOttoV2Project?.deepFreezeTask?.status === 'PENDING' ? <FreezeBanner>
          <FontAwesomeIcon icon={faBoxArchive} color='#F1AA3E' />
          <div className='txt'>
            <span className='bold-text'>Freezing in Progress...</span> Your project is being frozen.
            <Spin style={{marginLeft: '10px'}} indicator={<LoadingOutlined style={{fontSize: '14px', color: '#FFFFFF'}} spin />} />
          </div>
        </FreezeBanner> : ''}
        <Row gutter={[34, 14]} style={{minHeight: 250}}>
          <Col md={24} lg={24} xl={12}>
            <OttoSummary
              currentProject={currentProject}
              currentProjectLoader={currentProjectLoader}
              openSettings={openSettings}
              onChangeAutoPilot={onChangeAutoPilot}
              loadingAutoPilot={loadingAutoPilot}
            />
          </Col>
          <Col md={24} lg={24} xl={12}>
            <OttoCtaSection
              setGbpModalVisible={setGbpModalVisible}
              handleOpenGSCModal={handleOpenGSCModal}
              setIsKnowledgeModalVisible={setIsKnowledgeModalVisible}
              openSettings={openSettings}
              tooltipShown={tooltipShown}
              handleLaterClick={handleLaterClick}
              knowledgeGraphInitialLoader={knowledgeGraphInitialLoader}
              currentProjectLoader={currentProjectLoader}
            />
          </Col>
        </Row>

      </HeadingContainer>
      {isKnowledgeModalVisible && <OttoDetailKnowledgeGraph />}
      <SettingsModal
        // currentProject={currentProject}
        isVisible={settingsModal}
        setIsVisible={setSettingsModal}
        instructionsData={settingsData}
        setInstructionsData={setSettingsData}
      />
      {/* use this modal in another component */}
      <ImportBusinessModalV2
        onOttoGBPConnect={() => {
          loadOttoV2Project(uuid);
        }}
        visible={gbpModalVisible}
        setVisible={setGbpModalVisible}
        ottoProjectId={getOttoV2Project?.uuid}
        ottoConnectedGBPId={getOttoV2Project?.connectedData?.gbpDetailsV2}
        fromOtto={`?uuid=${uuid}`}
        isOttoV2
      />
      <WidgetModal
        isWidgetModalVisible={isWidgetModalVisible}
        setIsWidgetModalVisible={setIsWidgetModalVisible}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        uuid={createProjectUuid}
        setUuid={setCreateProjectUuid}
        handleSeeTasks={item => handleSeeTask({...item, siteAudit: item?.id, uuid: item?.ottoProjectUuid})}
      />
      <TopupModal topUpBulkVisibility={topUpBulkVisibility} setTopUpBulkVisibility={setTopUpBulkVisibility} />
      <DeepFreezeModal visible={deepFreezeModalVisible} setVisible={setDeepFreezeModalVisible} />
    </HeaderWrapper>
  </>
  );
});

export const StyledTab = styled.div<{showErrorIndicator?: boolean}>`
position: relative;
padding-left: 3px;
  ${p => p?.showErrorIndicator ? `
    padding-right: 6px;
    &::before {
      content: '';
      width: 7px;
      border-radius: 999px;
      height: 7px;
      background-color: #ff4d4f;
      position: absolute;
      top: 3px;
      left: 100%;
    }
  ` : ''}
`;
const HeadingContainer = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #FFFFFF;
  align-items: center;
  margin-bottom: 47px;
`;
const HeaderWrapper = styled.div`
  width: 100%;
  margin: auto;
`;
const BackContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  .back-icon {
    color: #A3A4A4;
    cursor: pointer;
  }
  .back-text {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    color: #A3A4A4;
    cursor: pointer;
  }
`;


const DomainWrapper = styled.div<{isFrozen?: boolean; isPublicPage?: boolean}>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: baseline;
  margin-bottom: ${p => p?.isPublicPage ? '20px' : p?.isFrozen ? '8px' : '30px'};
  .button-wrapper {
    display: flex;
    align-items: center;
    gap: 20px
  }

`;

const DomainContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  margin-top: 10px;
  .logo {
    width: 42px;
    height: 42px;
    background-color: #A3A4A4;
  }
  .title {
    font-family: Inter;
    font-size: 24px;
    font-weight: 600;
    line-height: 29px;
    letter-spacing: 0em;
    text-align: left;
    color: #FFFFFF;
  }
  .domain {

  }
`;

const StyledButton = styled(Button)<{isSetting?: boolean}>`
  background: ${p => p.isSetting ? '#4E515680': '#2AC15526'}!important;
  border-radius: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  color: #FFFFFF;
  padding: 5px 19px;
  margin: 0px;
  width: fit-content;
  &:hover, &:focus,&:active{
  background: ${p => p.isSetting ? '#676b7280': '#46f17725'}!important;
}
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const KnowledgeButton = styled(Button)`
  background: rgba(52, 174, 243, 0.15);
  border-radius: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  color: #FFFFFF;
  padding: 5px 19px;
  margin: 0px;
   &:hover, &:focus,&:active{
  background: rgba(52, 174, 243, 0.15) !important;
}
`;

export const StyledModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;
  .cancel-btn {
    width: 47px;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #4E5156;
    cursor: pointer;
  }
  .green-btn {
    background-color: #1FAC47 !important;
  }
  .mark-fields-button {
    outline: none;
    border: none;
    background-color: transparent;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: #2D6CCA;
    font-size: 12px;
  }
`;

const Link = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;
  color: #34AEF3;
  cursor: pointer;
`;

export const FreezeBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8.88px;
  margin-bottom: 8px;
  width: 100%;
  height: 38px;
  border-radius: 12px;
  background: #F1AA3E26;
  box-shadow: 0px 3px 2px 0px #00000005;
  padding: 0px 8px;
  .deep-freeze-banner-txt {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.52px;
    text-align: left;
  }
  .txt {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.94px;
    text-align: left;
    color: #FFFFFF;
    .unfreeze-button {
      font-family: Inter;
      font-size: 14px;
      font-weight: 500;
      line-height: 16.94px;
      text-align: left;
      text-decoration: underline;
      cursor: pointer;
    }
    .bold-text {
      font-family: Inter;
      font-size: 14px;
      font-weight: 700;
      line-height: 16.94px;
      text-align: left;
      color: #FFFFFF;
    }
  }
`;

const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

const Cms = styled.div`
  padding: 2px 8px;
  width: fit-content;
  height: fit-content;
  border-radius: 25px;
  background: #FFFFFF40;
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 12.1px;
  color: #FFFFFF;
`;
